export const CHANGE_TOKEN = "CHANGE_TOKEN";
export const CHANGE_ACCESS_TOKEN = "CHANGE_ACCESS_TOKEN";
export const CHANGE_FCM_TOKEN = "CHANGE_FCM_TOKEN";
export const CHANGE_JWT_TOKEN = "CHANGE_JWT_TOKEN";
export const RESET_TOKEN_STORE = "RESET_TOKEN_STORE";

export function changeFcmToken(fcmToken) {
  return {
    fcmToken,
    type: CHANGE_FCM_TOKEN,
  };
}

export function changeToken(token) {
  return {
    token,
    type: CHANGE_TOKEN,
  };
}

export function changeAccessToken(accessToken) {
  return {
    accessToken,
    type: CHANGE_ACCESS_TOKEN,
  };
}

export function changeJWT(jwt) {
  return {
    jwt,
    type: CHANGE_JWT_TOKEN,
  };
}

export function resetTokenStore() {
  return {
    type: RESET_TOKEN_STORE,
  };
}
